/* eslint-disable no-return-assign */

'use-strict';

import { IScope } from 'angular';
import { RootScope } from '../../../app.config';
import { FileService } from '../../../shared/storage/file.service';
import { ToastService, ToastType } from '../../toast/toast.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { UsersService } from '../../../shared/users/users.service';
import { File } from '../../../src/app/@shared-types/misc/file';

/* @ngInject */
export default class FileController {
  private $rootScope: RootScope;

  private $scope: IScope;

  private fileService: FileService;

  private toastService: ToastService;

  private interfaceService: InterfaceService;

  private usersService: UsersService;

  public downloading = false;

  public uploaderName = '';

  public deleteSecondStep = false;

  public file?: File;

  public fileId?: string;

  public fileIcon = '';

  constructor(
    $rootScope: RootScope,
    $scope: IScope,
    fileService: FileService,
    toastService: ToastService,
    interfaceService: InterfaceService,
    usersService: UsersService,
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.fileService = fileService;
    this.toastService = toastService;
    this.interfaceService = interfaceService;
    this.usersService = usersService;
  }

  async $onInit(): Promise<void> {
    if (!this.fileId && !this.file) throw new Error('Either fileId or file must be provided');

    this.downloading = false;
    this.uploaderName = '';
    this.deleteSecondStep = false;

    /** Get `File` if only id is provided */
    if (!this.file && this.fileId) {
      const file = await this.fileService.getFileMeta(this.fileId);
      this.file = file;
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.uploaderName = this.usersService.getNameOfUser(this.file!.uploader);
    this.fileExtensionToIcon();
  }

  public deleteFile = async (fileId: string): Promise<void> => {
    this.fileService
      .deleteFile(fileId)
      .then(() => {
        this.toastService.toast(ToastType.SUCCESS, 'Die Datei wurde gelöscht.');
        this.$rootScope.$emit('updateSalesTableDetail');
      })
      .catch((err) => {
        this.toastService.toast(ToastType.ERROR, 'Fehler beim Löschen der Datei.');
        console.error(err);
      });
  };

  public downloadFile = async (
    fileId: string,
    fileName: string,
  ): Promise<void> => {
    this.downloading = true;

    this.fileService.getFile(fileId, fileName)
      .then(() => {
        this.downloading = false;
        this.interfaceService.applyScope(this.$scope);
      })
      .catch((e) => {
        this.downloading = false;
        this.toastService.toast(ToastType.ERROR, 'Fehler beim Herunterladen der Datei.');
        console.error(e);
      });
  };

  /**
   * Depending on the file's content_type a FontAwesome icon is selected
   */
  private fileExtensionToIcon = (): void => {
    if (!this.file) return;

    switch (this.file.content_type) {
      case 'application/pdf':
        this.fileIcon = 'fad fa-file-pdf';
        break;
      case 'image/jpeg':
      case 'image/png':
        this.fileIcon = 'fad fa-file-image';
        break;
      default:
        this.fileIcon = 'fad fa-file';
        break;
    }
  };
}
